import { render, staticRenderFns } from "./result-btn.vue?vue&type=template&id=1f837106"
import script from "./result-btn.vue?vue&type=script&lang=js"
export * from "./result-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports